import { render, staticRenderFns } from "./HappeningNow.vue?vue&type=template&id=5a099793&scoped=true"
import script from "./HappeningNow.vue?vue&type=script&lang=js"
export * from "./HappeningNow.vue?vue&type=script&lang=js"
import style0 from "./HappeningNow.vue?vue&type=style&index=0&id=5a099793&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a099793",
  null
  
)

export default component.exports